import { getCustomTheme } from "theme";

const palettes = {
    spaceGray: {
        primary: {
            50: "#f6f7f9",
            100: "#ebeef3",
            200: "#d3d9e4",
            300: "#adbacc",
            400: "#8094b0",
            500: "#607797",
            600: "#4c5f7d",
            700: "#3e4d66",
            800: "#364256",
            900: "#313a49",
            950: "#242a36",
        },
    },
    blue: {
        primary:{
            50: "#f2f5fc",
            100: "#e1e9f8",
            200: "#cad8f3",
            300: "#a5bfeb",
            400: "#7a9ee0",
            500: "#5a7ed7",
            600: "#4663ca",
            700: "#3c51b9",
            800: "#364497",
            900: "#303c78",
            950: "#242a50",
        }
    },
    golden: {
        primary:{
            50: "#f9f7f3",
            100: "#f0ede4",
            200: "#dad0bb",
            300: "#cdbfa4",
            400: "#b8a17f",
            500: "#aa8b65",
            600: "#9d7a59",
            700: "#83644b",
            800: "#6b5241",
            900: "#574437",
            950: "#2e231c",
        }
    },
};

export const themes = {
    spaceGray: getCustomTheme(palettes.spaceGray),
    blue: getCustomTheme(palettes.blue),
    golden: getCustomTheme(palettes.golden),
};
